import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../content/CommonStyles.module.css";
import { FloatLabel } from "primereact/floatlabel";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { useState } from "react";

const QuantityPickerSidebar = ({visible, onHide, selectedRemaining, onSelect}) => {

    const [selectedProductQuantity, setSelectedProductQuantity] = useState(selectedRemaining ?? 0);

    return(<Sidebar visible={visible} position="right" onHide={onHide} className={`${commonStyle.sidebarmoved} ${commonStyle.shortSideBar}`}>
        <div className={commonStyle.formInput}>
            <div className="p-inputgroup flex-column">
                <FloatLabel>
                    <InputNumber value={selectedProductQuantity}
                        onChange={(e) => setSelectedProductQuantity(e.value)}
                        max={selectedRemaining?.total_quantity}
                        className="w-full"
                        maxFractionDigits={selectedRemaining?.measurement_units === "PIECES" ? 0 : 2}/>
                    <label>Кількість</label>
                </FloatLabel>
            </div>
        </div>
        <div>
            <Button label="Додати" severity="success" type="button" onClick={() => { onSelect(selectedProductQuantity) }} className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
        </div>
    </Sidebar>)
}

export default QuantityPickerSidebar;